import { styled } from '@stitches/configed';

const ButtonStyled = styled('button', {
  '&:hover, &:focus, &:active, &.active': {
    outline: 0,
    boxShadow: 'none',
  },
  '@xl': {
    padding: '0.625rem 1rem',
    fontSize: '0.813rem',
  },

  uTextSize: 'md',
  fontWeight: 500,
  // width: '100%',
  borderRadius: '0.375rem',
  padding: '16px 20px',
  backgroundColor: '#F7F8F9',
  variants: {
    btnType: {
      primary: {
        fontWeight: 600,
        backgroundColor: '$brand',
      },
      danger: {
        backgroundColor: '',
      },
      warning: {},
    },
    size: {
      lg: {
        padding: '1.375rem 3rem',
        fontSize: '1.125rem !important',
        '@sm': {
          padding: '0.75rem 1.25rem',
        },
      },
      sm: {
        fontSize: '0.813rem  !important',
        padding: '0.625rem 1rem',
      },
      md: {
        padding: '0.875rem 1.25rem',
      },
      xs: {
        fontSize: '0.75rem',
        padding: '0.438rem 1rem',
        fontWeight: 600,
      },
    },
    sharp: {
      square: {
        borderRadius: 0,
      },
    },
    transparent: {
      true: {
        backgroundColor: 'transparent',
      },
    },
  },
  compoundVariants: [
    {
      btnType: 'danger',
      transparent: 'true',
      css: {
        color: '$danger',
        '&:hover': {
          color: '#fff',
          backgroundColor: '$danger',
        },
      },
    },
    {
      btnType: 'primary',
      transparent: 'true',
      css: {
        color: '$brand',
        backgroundColor: 'transparent',
        '&:hover': {
          color: '#fff',
          backgroundColor: '$brand',
        },
      },
    },
  ],
});

export default ButtonStyled;
